<div class="anc-info-block">
    <label class="anc-info-block__label" translate
        >{{ label() }}<sup class="anc-info-block__req" *ngIf="required()">*</sup></label
    >
    <div
        class="anc-info-block__value"
        [class.anc-info-block__value--multiline]="multiline()"
        [attr.dir]="valueDir()"
        [title]="value()"
    >
        <ng-content>{{ value() || '-' }}</ng-content>
    </div>
</div>
